import { useState, useCallback } from 'react';

/**
 * useMiscState
 *
 * Owns the remaining small state fields that don't belong to a dedicated hook:
 *   returnSaved          — true after a successful return_save
 *   bankID               — bankDoc ID from return_print_query
 *   hasConfirmedClose    — true after user confirms return close
 *   toggleTaxpassReload  — toggled on send_taxpass_message to trigger re-fetch
 *   useYtyOptions        — true when the YTY transfer-options modal path is active
 *   restrictedFieldData  — restricted field info from return_restricted_field
 *   fieldFormLinks       — form-link data from return_linkage
 *   requireFilingStatusDlg — whether the "filing status required" dialog is open
 */
const useMiscState = () => {
  const [returnSaved, setReturnSaved] = useState(false);
  const [bankID, setBankID] = useState(0);
  const [hasConfirmedClose, setHasConfirmedClose] = useState(false);
  const [toggleTaxpassReload, setToggleTaxpassReload] = useState(true);
  const [useYtyOptions, setUseYtyOptions] = useState(false);
  const [restrictedFieldData, setRestrictedFieldData] = useState(null);
  const [fieldFormLinks, setFieldFormLinks] = useState({});
  const [requireFilingStatusDlg, setRequireFilingStatusDlg] = useState(false);

  const toggleTaxpassReloadFlag = useCallback(() => {
    setToggleTaxpassReload(prev => !prev);
  }, []);

  const openRequireFilingStatusDlg = useCallback(() => setRequireFilingStatusDlg(true), []);
  const closeRequireFilingStatusDlg = useCallback(() => setRequireFilingStatusDlg(false), []);

  return {
    returnSaved,
    setReturnSaved,
    bankID,
    setBankID,
    hasConfirmedClose,
    setHasConfirmedClose,
    toggleTaxpassReload,
    setToggleTaxpassReload,
    toggleTaxpassReloadFlag,
    useYtyOptions,
    setUseYtyOptions,
    restrictedFieldData,
    setRestrictedFieldData,
    fieldFormLinks,
    setFieldFormLinks,
    requireFilingStatusDlg,
    setRequireFilingStatusDlg,
    openRequireFilingStatusDlg,
    closeRequireFilingStatusDlg,
  };
};

export default useMiscState;
